<template>
    <div class="centerWidth">
        <div class="gaokao-nav">
            <span @click="goMyCenter">个人中心 ></span>
            <span>学生学情档案</span>
        </div>
        <my-file v-show="tabId == 1"></my-file>
        <my-grade v-show="tabId == 2"></my-grade>
        <my-general v-show="tabId == 3"></my-general>
        <my-direction v-show="tabId == 4"></my-direction>
    </div>
</template>

<script>
import myFile from './file.vue';
import myGrade from './grade.vue';
import myGeneral from './general.vue';
import myDirection from './direction.vue';
import Cookies from 'js-cookie';
export default {
    components: {
        myFile,
        myGrade,
        myGeneral,
        myDirection
    },
    data() {
        return {
            tabId: 1
        };
    },
    watch: {
        tabId() {
            document.querySelector('body').scrollTo(0, 0);
            window.scrollTo(0, 0);
        }
    },
    mounted() {
        if (this.$route.query.key) {
            Cookies.set('fileindex_key', this.$route.query.key);
            console.log('保存了key=' + this.$route.query.key);
        } else {
            this.$router.back(-1);
        }
    },
    methods: {
        // 个人中心
        goMyCenter() {
            this.$router.push('/myIndex');
        }
    }
};
</script>

<style scoped></style>
